<template>
  <b-modal id="seeReport"
           title="BreakDown Report"
           :ok-only = "true"
           ok-title = "Close"
           :lazy="true"
  >
    <!-- TODO@PONY need fix URL -->
    <iframe :src="url"
            width="100"
            frameborder = "0"
            size="lg"
            class="iframe">

    </iframe>

  </b-modal>

</template>

<script>
  export default {
    components: {
    },
    created () {

    },
    data () {
      return {

      }
    },
    computed: {
      url () {
        var demostring = ''
        var demos = this.$store.getters['order/demos']
        for (let item of demos) {
          demostring = demostring + item.title + ':}}'
          if (demos.length !== 1) {
            for (let subitem of item.values) {
              demostring = demostring + subitem.title + ';'
            }
          }
          demostring = demostring + '}}}}'
        }
        return this.$store.getters['config/link']('reportBreakdown') + '?sid=' + this.$store.state.order.ListModuleSessionId + '&demo=' + demostring
      }
    },
    watch: {
    },
    methods: {
    }
  }
</script>

<style scoped lang="scss">
  .iframe {
    display: block;
    width: 100%;
    height: 600px;
    border: 0;
  }

</style>
<style>
  [aria-labelledby=seeReport___BV_modal_header_] {
    width: 630px;
  }
</style>



// WEBPACK FOOTER //
// src/components/summary/MDemoBreakdownReport.vue